import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

const categoryIcons: Record<string, string> = {
  romance: 'ri-heart-line',
  fantasy: 'ri-magic-line',
  action: 'ri-fire-line',
  drama: 'ri-building-line',
  thriller: 'ri-search-eye-line',
  comedy: 'ri-emotion-laugh-line',
  horror: 'ri-ghost-line',
  'slice-of-life': 'ri-sun-line',
};

const categoryImages: Record<string, string> = {
  romance: 'https://readdy.ai/api/search-image?query=A%20soft%20romantic%20anime%20style%20illustration%20with%20cherry%20blossom%20petals%2C%20warm%20pink%20and%20coral%20tones%2C%20gentle%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-romance&orientation=landscape',
  fantasy: 'https://readdy.ai/api/search-image?query=A%20magical%20fantasy%20anime%20style%20illustration%20with%20floating%20crystals%20and%20sparkles%2C%20warm%20amber%20and%20gold%20tones%2C%20enchanting%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-fantasy&orientation=landscape',
  action: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20anime%20style%20illustration%20with%20motion%20lines%20and%20energy%20bursts%2C%20warm%20red%20and%20orange%20tones%2C%20intense%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-action&orientation=landscape',
  drama: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20urban%20anime%20style%20illustration%20with%20city%20skyline%2C%20warm%20brown%20and%20cream%20tones%2C%20modern%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-drama&orientation=landscape',
  thriller: 'https://readdy.ai/api/search-image?query=A%20mysterious%20noir%20anime%20style%20illustration%20with%20shadows%20and%20silhouettes%2C%20dark%20warm%20tones%2C%20suspenseful%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-thriller&orientation=landscape',
  comedy: 'https://readdy.ai/api/search-image?query=A%20playful%20colorful%20anime%20style%20illustration%20with%20fun%20patterns%2C%20bright%20warm%20yellow%20and%20coral%20tones%2C%20cheerful%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-comedy&orientation=landscape',
  horror: 'https://readdy.ai/api/search-image?query=A%20creepy%20dark%20anime%20style%20illustration%20with%20fog%20and%20mysterious%20shapes%2C%20deep%20warm%20red%20and%20black%20tones%2C%20eerie%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-horror&orientation=landscape',
  'slice-of-life': 'https://readdy.ai/api/search-image?query=A%20cozy%20warm%20anime%20style%20illustration%20with%20sunlight%20through%20window%2C%20gentle%20cream%20and%20beige%20tones%2C%20peaceful%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=300&seq=cat-slice&orientation=landscape',
};

export default function CategoryShowcase() {
  const displayCategories = categories.filter((c) => c.id !== 'all');

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            探索漫画分类
          </h2>
          <p className="text-sm text-foreground-500">找到你最爱的那一类漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[4/3] cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug] || categoryImages.romance}
                alt={`${cat.name}漫画 - 虫虫漫画`}
                title={`${cat.name}韩国漫画分类`}
                className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-foreground-900/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className={`${categoryIcons[cat.slug] || 'ri-bookmark-line'} text-sm text-background-50 w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="text-base font-heading font-bold text-background-50">
                    {cat.name}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}